<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px">
        <v-layout row style="padding: 0px">
          <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="getData()"
            >
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <span>Play</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateToMenu"
                :close-on-content-click="false"
                v-model="dateToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>

      <v-divider></v-divider>

      <v-container fluid class="pa-2">
        <v-layout row>
          <v-flex sm4 md4 class="pl-0">
            <v-btn @click="openFilterExpansion">
              <v-icon class="mr-3">
                {{ openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
              </v-icon>
              <span>Filter {{ title }}</span>
            </v-btn>
          </v-flex>
          <v-flex sm8 md8></v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <filter-panel :openFilter="openFilter">
        <v-flex md4>
          <v-select
            v-model="filterCompany"
            :items="filterCompanies"
            label="By Company"
            solo
            clearable
          ></v-select>
        </v-flex>
        <v-flex md4>
          <v-select
            v-model="filterTerminal"
            :items="filterTerminals"
            label="By Terminal"
            solo
            clearable
            :disabled="!filterCompany"
          ></v-select>
        </v-flex>
      </filter-panel>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                header.value === queryParams.order ? 'active' : '',
                'text-xs-' + header.align,
              ]"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-center">
            {{ props.item.terminal.toUpperCase() }}
          </td>
          <td class="text-lg-center">
            {{
              props.item.items.reduce((ac, c) => {
                return ac + c.reload_count;
              }, 0)
            }}
          </td>
          <td class="text-xs-center">
            {{
              $amountInPeso(
                props.item.items.reduce((ac, c) => {
                  return ac + c.reload_gross;
                }, 0)
              )
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.items
                .reduce((ac, c) => {
                  return ac + c.sold_count;
                }, 0)
            }}
          </td>
          <td class="text-xs-center">
            {{
              $amountInPeso(
                props.item.items.reduce((ac, c) => {
                  return ac + c.sold_gross;
                }, 0)
              )
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.items.reduce((ac, c) => {
                return ac + (c.sold_count + c.reload_count);
              }, 0)
            }}
          </td>
          <td class="text-xs-center">
            {{
              $amountInPeso(
                props.item.items.reduce((ac, c) => {
                  return ac + (c.sold_gross + c.reload_gross);
                }, 0)
              )
            }}
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
import "jspdf-autotable";

export default {
  components: {},
  data() {
    return {
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      dateGenerateMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      dateFrom: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      dateTo: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      date: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      title: "Daily Units Per Terminal",
      items: [],
      headers: [
        { text: "#", align: "left", sortable: false },
        {
          text: "Branch",
          align: "center",
          value: "terminal",
          sortable: true,
        },
        {
          text: "Reload Count",
          align: "center",
          value: "reload_count",
          sortable: true,
        },
        {
          text: "Reload Gross",
          align: "center",
          value: "reload_gross",
          sortable: true,
        },
        {
          text: "Free Cards",
          align: "center",
          value: "sold_count",
          sortable: true,
        },
        {
          text: "Replacement Gross",
          align: "center",
          value: "sold_gross",
          sortable: true,
        },
        {
          text: "Total Count",
          align: "center",
          value: "total_count",
          sortable: true,
        },
        {
          text: "Total Gross",
          align: "center",
          value: "total_gross",
          sortable: true,
        },
      ],
      queryParams: {
        offset: 0,
        date_from: null,
        date_to: null,
        terminal_id: null,
        company_id: null,
        date: null,
        limit: null,
      },
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewData: {},
      viewItems: [],

      openConfirmDialog: false,
      confirmLoading: false,

      companies: [],
      subcompanies: [],
      terminals: [],

      filterCompany: "",
      filterTerminal: "",

      filterCompanies: [],
      filterTerminals: [],
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.queryParams.terminal_id = null;
        await this.setTerminals();
      } else if (this.filterCompany === undefined) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.filterTerminal = null;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.filterTerminal = null;
      }
    },
    filterTerminal: async function() {
      if (
        this.filterTerminal !== null &&
        this.filterTerminal !== undefined &&
        this.filterTerminal !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.terminal_id = this.filterTerminal;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.terminal_id = null;
      }
    },
  },
  created: async function() {
    await this.$store.commit("initiateTempData");
  },
  computed: {
    computedItems() {
      return this.$store.state.tempData;
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  methods: {
    async getData(reset) {
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.dateTo + " " + this.timeTo + ":59";
      this.queryParams.terminal_id = this.filterTerminal;
      this.queryParams.company_id = this.filterCompany;

      if (reset) {
        this.queryParams.offset = 0;
        await this.$store.commit("initiateTempData");
      }

      try {
        const response = await Services.getDailyUnitsPerTerminal(
          this.queryParams
        );

        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    refreshData() {
      this.dateFrom = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.filterCompany = null;
      this.getData(true);
    },
    async setCompanies() {
      this.companies = [];
      const items = (
        await Services.getCompanies({
          project_id: this.$store.state.employee.project_id,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.companies.push(data);
      }

      this.filterCompanies = Array.from(
        new Set(this.companies.map(JSON.stringify))
      ).map(JSON.parse);
    },
    async setTerminals() {
      this.terminals = [];
      const items = (
        await Services.getTerminals({
          company_id: this.filterCompany,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.terminals.push(data);
      }

      this.filterTerminals = Array.from(
        new Set(this.terminals.map(JSON.stringify))
      ).map(JSON.parse);
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setCompanies();
    },
    async openDialog(data) {
      this.viewItems = [];
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = data.items;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
    async downloadExcel(data) {
      this.$store.dispatch("startLoading");

      this.items;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();

      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(this.items[e].terminal);
        theItem.push(
          this.items[e].items.reduce((ac, c) => {
            return ac + c.reload_count;
          }, 0)
        );
        theItem.push(
          this.items[e].items.reduce((ac, c) => {
            return ac + c.reload_gross;
          }, 0)
        );
        theItem.push(
          this.items[e].items
            .reduce((ac, c) => {
              return ac + c.sold_count;
            }, 0)
        );
        theItem.push(
          this.items[e].items.reduce((ac, c) => {
            return ac + c.sold_gross;
          }, 0)
        );
        theItem.push(
          this.items[e].items.reduce((ac, c) => {
            return ac + (c.sold_count + c.reload_count);
          }, 0)
        );

        theItem.push(
          this.items[e].items.reduce((ac, c) => {
            return ac + (c.sold_gross + c.reload_gross);
          }, 0)
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
table.v-table thead th {
  font-size: 14px !important;
}
table.v-table tbody td {
  font-size: 14px !important;
}
</style>
